import { Grid, Box, Button } from "@mui/material";

import { FC, useEffect, useState } from "react";
import { load, remove } from "../../constants/storage";
import DashboardNavbar from "../../components/DashboardNavbar";
import { H4, H6 } from "../../components/Typography";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-hot-toast";
import {
  addBankAccount,
  getBankDetails,
} from "../../redux/actions";
import { useAppDispatch } from "../../store/hooks";
import AddBankModel from "../../components/AddBankModel";
import BankCard from "../../components/BankCard";

const BankDetails: FC = () => {
  let navigate = useNavigate();
  //get User Address
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [bankData, setBankData] = useState([]);

  const [openModal, setOpenModal] = useState(false);
  //get Address
  useEffect(() => {
    checkToken();
  }, []);

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      getBankDetailsData();
    }
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const getBankDetailsData = async () => {
    setLoading(true);
    let token = load("token");
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);

    dispatch(getBankDetails(finalUser.id, token))
      .then(async (response: any) => {
        setBankData(response);
        setLoading(false);
      })
      .catch((error: any) => {
        if (error === undefined) {
          setLoading(false);
          setBankData([]);
        }
        setLoading(false);
        // setBankData([]);
      });
  };

  const handleSave = (value: any) => {
    setLoading(true);
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    const data = {
      mobileNo: finalUser.mobile,
      fullName: value.fullname,
      accountNumber: value.accountNo,
      ifscCode: value.ifscCode,
      consent: "true",
      bankName: value.bank_name,
      userId: finalUser.id,
    };
    console.log(data);
    let token: any = load("token");
    dispatch(addBankAccount(data, token))
      .then(async (response: any) => {
        setLoading(false);
        if (response.code === 0) {
          toast.success("Bank account added sucessfully");
          handleCloseModal();
          getBankDetailsData();
          setLoading(false);
        }
        if (response.code === 2011) {
          toast.error(response.error);
          setLoading(false);
          return;
        }
        if (response.code === 2010) {
          toast.error(response.error);
          setLoading(false);
          return;
        }
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error);
      });
  };
  return (
    <>
      <DashboardNavbar />
      <Grid
        container
        sx={{
          background: "#F6F6F6",
          height: "100vh",
          justifyContent: "center",
        }}
      >
        {loading ? (
          <Grid
            height="100vh"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </Grid>
        ) : (
          <>
            <Grid
              sx={{
                pl: {
                  md: 9,
                  xs: 2,
                  sm: 2,
                },
                pr: {
                  md: 9,
                  xs: 2,
                  sm: 2,
                },
                pb: 10,
                pt: 2,
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
                flex: 1,
              }}
            >
              <AddBankModel
                open={openModal}
                handleClose={handleCloseModal}
                handleSave={handleSave}
                //nameValue={inputValue}
              />
              <Grid
                xs={12}
                sx={{
                  background: "#FFFFFF",
                  p: {
                    md: 4,
                    xs: 2,
                  },
                  width: "100%",
                  // alignItems: "center",
                  //justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 2,
                }}
              >
                <H4
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                    textAlign: "left",

                    color: "#000",
                  }}
                  fontWeight={"600"}
                >
                  Bank Details
                </H4>
                {bankData.map((item: any) => (
                  <BankCard data={item} />
                ))}
                {bankData.length === 0 && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mt: 5,
                      flexDirection: "column",
                    }}
                  >
                    <H6
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                        textAlign: "left",

                        color: "#000",
                        mb: 2,
                      }}
                      fontWeight={"600"}
                    >
                      No bank account found.
                    </H6>
                    <Button
                      type="submit"
                      size="medium"
                      sx={{
                        flexDirection: "row",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: 2,
                        padding: 0.5,
                        paddingLeft: 2,
                        color: "#fff",
                        paddingRight: 2,
                        marginTop: 0.5,
                        background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                        fontSize: 14,
                        position: "relative",
                        justifyContent: "center",
                        width: "40%",
                        mt:5,
                        textTransform: "none",
                      }}
                      onClick={handleOpenModal}
                    >
                      Add Bank
                    </Button>
                  </Box>
                )}
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default BankDetails;
const buttonView = {
  flexDirection: "row",
  display: "flex",
  alignItems: "center",
  borderRadius: 2,
  padding: 0.5,
  paddingLeft: 2,
  color: "#fff",
  paddingRight: 2,
  marginTop: 0.5,
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  fontSize: 14,
  position: "relative",
  justifyContent: "center",
  width: {
    md: "30%",
    xs: "100%",
  },
};
